define('ordersDetailMessagesFooterAttachmentView',[
  'module',
  'underscore',
  'marionette',
  'template!ordersDetailMessagesFooterAttachmentView'
], function (
  Module,
  _,
  Marionette,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'footer-attachment-view',

    events: { 
      'click': 'onDelete'
    },

    serializeData: function () {
      return {
        value: this.model.get('name')
      };
    },

    onDelete: function (e) {
      e.stopPropagation();
      this.trigger('delete', this.model);
    }
  });
});
